import getForms from './getForms'
import getTareas from './getTareas'

export const getTareasPromise = getTareas
